const nilValues = [null, void 0, ""];
const nullOrUndefined = [null, void 0];
const isNilValue = (value) => {
  return nilValues.includes(value);
};
const notNil = (value) => !isNilValue(value);
const isNil = (value) => {
  return nullOrUndefined.includes(value);
};
export {
  isNil as a,
  isNilValue as i,
  notNil as n
};
//# sourceMappingURL=isNilValue.js.map
